/* @generated */
import * as React from "react";
import { visuallyHidden } from "./visually-hidden.css.esm.js";
const VisuallyHidden = ({
  children
}) => /* @__PURE__ */ React.createElement("span", { className: visuallyHidden }, children);
export {
  VisuallyHidden
};
